export const NAME = 'newsletterSubscription';

export const REQUEST_SUBSCRIBE = 'REQUEST_SUBSCRIBE';
export const SUCCESS_SUBSCRIBE = 'SUCCESS_SUBSCRIBE';
export const FAILURE_SUBSCRIBE = 'FAILURE_SUBSCRIBE';

export const RESET_FORM_SUBMIT_SUBSCRIBE = 'RESET_FORM_SUBMIT_SUBSCRIBE';



// WEBPACK FOOTER //
// ./src/services/newsletter/constants.js